import config from './config.js'

export default {

    checksource: function(ctrl,ds,cb) {
      config.post(ctrl,config.baseUrl + 'rest/datamap/sourcetest','Datenquelle prüfen',ds,cb);
    },

    listsources: function(ctrl,start,count,cb_success) {
        config.get(ctrl, config.baseUrl + 'rest/datamap/sources?start=0&count=1000&sort=name','Datenquellen laden',cb_success);
    },

    savesource: function(ctrl,data,cb_success) {
      config.post(ctrl,config.baseUrl + 'rest/datamap/sources','Datenquelle speichern',data,cb_success);
    },

    deletesource: function(ctrl,id,cb_success) {
      config.delete(ctrl, config.baseUrl + 'rest/datamap/sources/' + encodeURIComponent(id),'Datenquellen löschen',cb_success);
    },

    deletetable: function(ctrl,id,cb) {
      config.delete(ctrl, config.baseUrl + 'rest/datamap/tables/' + encodeURIComponent(id),'Tabellenmapping löschen',cb);
    },

    listtables: function(ctrl,start,count,sort,search,cb_success) {
      config.get(ctrl,config.baseUrl + 'rest/datamap/tables?start=' + start + '&count=' + count + '&sort=' + sort + '&search=' + encodeURIComponent(search),'Daten-Tabellen auflisten',cb_success);
    },

    loadtable: function(id,ctrl,cb_success) {
      config.get(ctrl,config.baseUrl + 'rest/datamap/tables/' + encodeURIComponent(id),'Daten Tabelle laden',cb_success);
    },

    exporttable: function(ctrl,id,exporter,download,cb_success) {
      config.post(ctrl,config.baseUrl + 'rest/datamap/tableexport?table=' + encodeURIComponent(id) + '&download=' + encodeURIComponent(download),'Tabelle exportieren',JSON.stringify(exporter),cb_success,(download ? 'blob' : 'json'));
    },

    savetable: function(ctrl,data,cb_success) {
      config.post(ctrl,config.baseUrl + 'rest/datamap/tables','Daten Tabelle speichern',JSON.stringify(data),cb_success);
    },

    loadsystable: function(ctrl,id,cb_success) {
      config.get(ctrl,config.baseUrl + 'rest/config/base?set=%5B%22data.mapping.' + encodeURIComponent(id) + '%22%5D','System-Tabelle laden',cb_success);
    },

    savesystable: function(ctrl,data,cb_success) {
      config.post(ctrl,config.baseUrl + 'rest/config/base','Datenkonfiguration speichern',JSON.stringify(data),cb_success);
    },

    listcolumns: function(tables) {
      var collist = [];
      var colreg  = {};
      for (var tidx in tables) {
        var table = tables[tidx];
        console.log(table);
        if (table && table.table && table.table.properties) {
          for (var p in table.table.properties) {
            var prop = table.table.properties[p];
            if (!colreg[prop.name]) {
              collist.push(prop.name);
              colreg[prop.name] = true;
            }
          }
        }
      }
      console.log('columns:',collist);
      return collist;
    }


}
